module.exports = __webpack_public_path__ + "static/img/ic_facebook.75f0a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/ic_facebook.png
// module id = 9cKl
// module chunks = 0